import client from './client';

export const getUnits = (params) =>
  client.get('/units-of-measure', { params }).then((r) => r.data);

export const createUnit = (data) =>
  client.post('/units-of-measure', data).then((r) => r.data);

export const getConversions = (params) =>
  client.get('/units-of-measure/conversions', { params }).then((r) => r.data);

export const createConversion = (data) =>
  client.post('/units-of-measure/conversions', data).then((r) => r.data);
